class BcHeroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.bc-hero__slide'));
    if (this.slides.length < 2) return;

    this.speed = (parseFloat(this.dataset.speed) || 5) * 1000;
    this.current = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (this.current < 0) this.current = 0;

    this.dots = Array.from(this.querySelectorAll('.bc-hero__dot'));
    this.prevButton = this.querySelector('.bc-hero__nav--prev');
    this.nextButton = this.querySelector('.bc-hero__nav--next');

    this.prevButton?.addEventListener('click', () => this.goTo(this.current - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.current + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.index, 10)));
    });

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());

    if (!this.reducedMotion.matches) this.play();

    this.activateSlideVideo(this.slides[this.current]);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) this.activateSlideVideo(this.slides[this.current]);
    });
  }

  activateSlideVideo(slide) {
    const video = slide?.querySelector('video');
    if (!video) return;
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Autoplay blocked (e.g. iOS Low Power Mode) — the poster image stays visible instead.
      });
    }
  }

  deactivateSlideVideo(slide) {
    const video = slide?.querySelector('video');
    if (video && !video.paused) video.pause();
  }

  play() {
    if (this.reducedMotion.matches) return;
    this.pause();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  pause() {
    clearInterval(this.timer);
  }

  next() {
    this.goTo(this.current + 1);
  }

  goTo(index) {
    const total = this.slides.length;
    const nextIndex = ((index % total) + total) % total;
    const previous = this.current;
    this.current = nextIndex;
    this.slides[previous].classList.remove('is-active');
    this.slides[this.current].classList.add('is-active');
    this.activateSlideVideo(this.slides[this.current]);
    this.deactivateSlideVideo(this.slides[previous]);
    if (this.dots.length) {
      this.dots[previous].classList.remove('is-active');
      this.dots[previous].setAttribute('aria-selected', 'false');
      this.dots[this.current].classList.add('is-active');
      this.dots[this.current].setAttribute('aria-selected', 'true');
    }
    this.play();
  }
}

customElements.define('bc-hero-slideshow', BcHeroSlideshow);
